import React from 'react';
import { Image, TouchableOpacity } from 'react-native';
import { Text } from 'react-native-web';
import { img_collapse } from '../../../utils/ImagesManagementUtils';

const SquareButton = ({
  title,
  onPress,
  blueTheme,
  showToggleButton,
}) => {
  const myStyles = {
    container: {
      width: 200,
      height: 50,
      borderRadius: 5,
      backgroundColor: blueTheme && '#008cff',
      border: !blueTheme && 'solid 1px #cbd5e0',
    },
    text: {
      margin: 'auto',
      fontFamily: 'Quicksand-Bold',
      fontSize: 18,
      color: blueTheme && 'white',
    },
    image: {
      position: 'absolute',
      width: 16,
      height: 16,
      top: 17,
      end: 10,
    },
  };
  return (
    <TouchableOpacity
      style={myStyles.container}
      onPress={onPress}
    >
      {showToggleButton && (
        <Image
          fadeDuration={0}
          style={myStyles.image}
          source={img_collapse}
        />
      )}
      <Text style={myStyles.text}>
        {title}
      </Text>
    </TouchableOpacity>
  );
};

export default SquareButton;
